import { useMutation } from '@tanstack/react-query';
import api from '@api/http/api';

export function useCheckPaymentsMutation() {
  return useMutation<{ success: true }>({
    mutationFn: () => api.post('/payments/check'),
  });
}
